module.exports = __webpack_public_path__ + "static/media/img-2.cf53e617.svg";